class StickyAddToCart extends HTMLElement {
  constructor() {
    super();

    this.form = null;
    this.footer = null;
    this.content = null;
    this.formInView = true;
    this.formAbove = false;
    this.footerInView = false;
    this.formObserver = null;
    this.footerObserver = null;
  }

  connectedCallback() {
    this.form = this.closest('[data-ref="product-form"]');
    // RDV (03/11/2026) : le pied de page sur mesure (footer.rdv-f) n'a pas data-ref="footer" ;
    // sans lui, la barre restait affichee tout en bas de la page.
    this.footer = document.querySelector('[data-ref="footer"]') || document.querySelector('footer.rdv-f');
    this.content = this.querySelector('.sticky-add-to-cart__content');

    if (!this.form || !this.content) return;

    // Réserve l'espace du sticky dans le flux pour éviter le changement de
    // hauteur du document quand le contenu passe en position: fixed. Sans cela,
    // le contenu sort du flux → la page raccourcit → le footer remonte dans le
    // viewport → le sticky se désactive → boucle infinie de clignotement.
    requestAnimationFrame(() => {
      this.style.minHeight = `${this.offsetHeight}px`;
      this.#initObservers();
    });
  }

  disconnectedCallback() {
    if (this.onScrollRdv) window.removeEventListener('scroll', this.onScrollRdv);
    this.formObserver?.disconnect();
    this.footerObserver?.disconnect();
  }

  #initObservers() {
    this.formObserver = new IntersectionObserver(([entry]) => {
      this.formInView = entry.isIntersecting;
      // RDV : la barre n'apparait qu'une fois le bouton d'achat DEPASSE vers le bas (formulaire au-dessus de l'ecran),
      // pas quand on est encore au-dessus du bouton.
      this.formAbove = !entry.isIntersecting && entry.boundingClientRect.top < 0;
      this.#updateDisplay();
    });

    this.formObserver.observe(this.form);

    // RDV : verification au defilement, en plus de l'observateur. Un saut instantane (retour en haut,
    // defilement tres rapide) peut passer par-dessus le formulaire sans que l'observateur ne le voie.
    this.onScrollRdv = () => {
      if (this.tickRdv) return;
      this.tickRdv = true;
      requestAnimationFrame(() => {
        this.tickRdv = false;
        const above = this.form.getBoundingClientRect().bottom < 0;
        if (above !== this.formAbove) {
          this.formAbove = above;
          this.#updateDisplay();
        }
      });
    };
    window.addEventListener('scroll', this.onScrollRdv, { passive: true });

    if (!this.footer) return;

    this.footerObserver = new IntersectionObserver(([entry]) => {
      this.footerInView = entry.isIntersecting;
      this.#updateDisplay();
    });

    this.footerObserver.observe(this.footer);
  }

  #updateDisplay() {
    const shouldBeActive = this.formAbove && !this.footerInView;
    const isActive = this.dataset.active === 'true';

    if (shouldBeActive === isActive) return;

    clearTimeout(this.closingTimeout);

    if (shouldBeActive) {
      delete this.dataset.closing;
      this.dataset.active = 'true';
      this.content.classList.add('color-scheme-1');
      return;
    }

    this.dataset.active = 'false';
    this.dataset.closing = 'true';

    this.closingTimeout = setTimeout(() => {
      delete this.dataset.closing;
      this.content.classList.remove('color-scheme-1');
    }, 300);
  }
}

if (!customElements.get('sticky-add-to-cart')) {
  customElements.define('sticky-add-to-cart', StickyAddToCart);
}
